
import * as React from 'react';
import { Col, Row, Icon, Select, message, Spin} from 'src/Library/AntdLibComponents';
import Drawer from 'antd/lib/drawer';
import injectSheet from 'react-jss';
import BookingDetails from '../BookingDetails';
import { BOOKING_STATUS } from '../Booking/BookingUtils';
import { getDateValue } from 'src/Library/Helper';
import {
  downloadContainers,
  resetPagination,
  setFilter,
  setPagination,
  resetAndSetBatchSize,
} from 'src/actions/summaryDashboardActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { defaultAccessKeys, visibleAccessTypeLabel } from '../InquiryUtils';
import TeamForInquiryAccessModal from '../Modals/TeamForInquiryAccessModal';
import { fetchAllTeams } from 'src/api/teams';
import { downloadBookingPurchaseOrder, fetchBookingDetail, updateBookingAccessType } from 'src/api/booking';
import { downloadFileData } from 'src/utils/utils';
import { tokens } from 'src/design-system';

const COLORS = {
  RED: '#F5222D',
  BLUE: tokens.colors.primary,
  GREEN: '#52C41A',
  ORANGE: '#ED8732',
};
const styles = {
  drawerClass: {
    '& .ant-drawer-header': {
      height: '58px',
    },
  },
  accessTypeDiv: {
    display: 'flex',
    width: '100%',
    '& .ant-select-selection--single': {
      border: 'unset',
      backgroundColor: '#F7F7F7',
      fontSize: `${tokens.fontSize.small}px`,
    },
    '& .ant-select': {
      minWidth: '60%',
      width: 'auto',
    },
  },
};

class BookingSideDrawer extends React.PureComponent<any, any> {
  constructor(props) {
    super(props);
  }

  state: any = {
    newDeadline: null,
    activeKey: '1',
    isLoading: true,
    inquiryData: null,
    ShipperBidsFilterModalVisible: false,
    sendRFQConfirmationVisible: false,
    ShipperBidsSortByModalVisible: false,
    filterModalVisible: false,
    bidsSortByModalVisible: false,
    clearVisible: false,
    deleteModalLoading: false,
    isDownloadLoading: false,
    shouldShipperResetFilter: true,
    bookingAccessTeams: {},
    bookingData: null,
    teams: [],
  };

  loadInquiryData = async () => {
    const { drawerData } = this.props;
    this.setState({ isLoading: true });
    if (drawerData) {
      this.setState({
        inquiryData: drawerData,
        newDeadline: drawerData?.deadline,
      });
    }
    this.setState({ isLoading: false });
  };

  loadBookingData = async () => {
    const { drawerData, userType } = this.props;

    this.setState({ isLoading: true });
    const response = await fetchBookingDetail({ bookingId: drawerData.id });
    if (response.isSuccess) {
      const isShipper = userType === 'SHIPPER';
      const { shipperAccessorType, ffAccessorType, shipperTeams, ffTeam } = response.data as any;
      const accessType = isShipper ? shipperAccessorType : ffAccessorType;
      const teams = (accessType === 'TEAM' ? (isShipper ? shipperTeams : [ffTeam]) : []) || [];
      const bookingAccessTeams = {};
      if (teams && teams?.length) {
        teams.forEach((team) => {
          bookingAccessTeams[team.id] = `${team.name} (${team.referenceNumber})`;
        });
      }
      this.setState({
        bookingData: response.data,
        bookingAccessTeams,
        accessType,
        isLoading: false
      });
    }
  };

  async componentDidMount() {
    const { isVisible } = this.props;
    this.setState({ isLoading: true });
    if (isVisible) await this.loadInquiryData();
    await this.loadBookingData();
    await this.fetchTeams();
  }

  updateTeamAccess = async (accessType, teamIds?: string[]) => {
    this.setState({ isLoading: true });
    const dataToSend: { bookingId: string; accessType: string; teamIds?: string[] } = {
      bookingId: this.props.drawerData.id,
      accessType,
      teamIds: teamIds || []
    };
    const response = await updateBookingAccessType(dataToSend);
    if (response.isSuccess) {
      this.setState({
        accessType,
        ...(!teamIds && { bookingAccessTeams: {} }),
        isLoading: false,
        isSelectTeamModalVisible: false,
      });
    } else {
      this.setState({ isLoading: false, isSelectTeamModalVisible: false });
      message.error(response.errorMessage);
    }
  };

  getColumns = (columnLabels) => {
    const columns: any = [];
    Object.keys(columnLabels).forEach((key, index) => {
      columns.push({
        key,
        width: 150,
        dataIndex: key,
        title: <span>{columnLabels[key]}</span>,
        render: (text, record) => {
          if (key === 'containerNumber') {
            return (
              <a
                href={`${window.location.origin}/container/tab/container?containerId=${record.containerId}&containerNumber=${record.containerNumber}&blNumber=${record.blNumber}&shippingLine=${record.shippingLine}`}
                target="_blank"
              >
                {record[key]}
              </a>
            );
          }
          return record[key];
        },
      });
    });
    return columns;
  };

  getTableData = (data) => {
    const tableData: any = [];
    data.map((valArr: any) => {
      const row: any = {};
      valArr.map((val, index) => {
        // row[`a${index}`] = val;
        row[val.id] = {
          index,
          ...val,
        };
      });
      tableData.push(row);
    });
    return tableData;
  };

  renderDot = (style, char) => {
    return (
      <div
        style={{
          marginBottom: '3px',
          height: '11px',
          width: '11px',
          borderRadius: `${tokens.radius.lg}px`,
          display: 'inline-block',
          verticalAlign: 'middle',
          ...style,
        }}
      >
        <span style={{ paddingLeft: '2px' }}>{char}</span>
      </div>
    );
  };

  bookingStatus = () => {
    const { drawerData, type } = this.props;
    const status = type === 'SHIPPER' ? drawerData.status : drawerData.ffStatus;
    const iconStyle = {
      color: '#fff',
      fontSize: '9px',
      top: '-7px',
      position: 'relative',
      left: '-1px',
    } as React.CSSProperties;

    let backgroundColor;
    let statusValue;
    let char;

    if (this.props.type === 'SHIPPER') {
      switch (status) {
        case 'OPEN': {
          backgroundColor = COLORS.BLUE;
          statusValue = 'Booking Requested';
          break;
        }
        case 'CONFIRMED': {
          backgroundColor = COLORS.GREEN;
          statusValue = 'Booked';
          char = <Icon style={iconStyle} type="check" />;
          break;
        }
        case 'CANCELLED': {
          backgroundColor = COLORS.RED;
          statusValue = 'Cancelled';
          break;
        }
        case 'DECLINED': {
          backgroundColor = COLORS.RED;
          statusValue = 'Declined';
          char = <Icon style={iconStyle} type="cross" />;
          break;
        }
        default: {
          backgroundColor = COLORS.BLUE;
          statusValue = 'Booking Requested';
          break;
        }
      }
    } else {
      switch (status) {
        case BOOKING_STATUS.OPEN: {
          backgroundColor = COLORS.BLUE;
          statusValue = 'Booking Received';
          break;
        }
        case BOOKING_STATUS.CONFIRMED: {
          backgroundColor = COLORS.GREEN;
          statusValue = 'Booked';
          char = <Icon style={iconStyle} type="check" />;
          break;
        }
        case BOOKING_STATUS.CANCELLED: {
          backgroundColor = COLORS.RED;
          statusValue = 'Cancelled';
          break;
        }
        case BOOKING_STATUS.DECLINED: {
          backgroundColor = COLORS.RED;
          statusValue = 'Declined';
          char = <Icon style={iconStyle} type="close" />;
          break;
        }
        case BOOKING_STATUS.SL_RESPONSE_AWAITED: {
          backgroundColor = COLORS.ORANGE;
          statusValue = `SL Response Awaited ${drawerData.inttraRequestIds?.length > 1 ? ' | Amended' : ''
            }`;
          break;
        }
        case BOOKING_STATUS.SL_RESPONDED: {
          backgroundColor = COLORS.BLUE;
          statusValue = 'SL Responded';
          break;
        }
        case BOOKING_STATUS.SL_ERRORED: {
          backgroundColor = COLORS.RED;
          statusValue = 'Errors Received';
          break;
        }
        default: {
          backgroundColor = COLORS.BLUE;
          statusValue = 'Booking Requested';
          break;
        }
      }
    }

    return (
      <div
        style={{
          fontWeight: tokens.fontWeight.semibold,
          fontSize: `${tokens.fontSize.body}px`,
          color: '#252323d9',
        }}
      >
        {this.renderDot(
          {
            backgroundColor,
            marginRight: '11px',
            marginLeft: '3px',
          },
          char ? char : ''
        )}
        <span style={{ fontSize: `${tokens.fontSize.body}px` }}>{statusValue}</span>
      </div>
    );
  };

  getDeadline = () => {
    const { drawerData } = this.props;
    let date = drawerData.statusDate;
    if (
      drawerData.ffStatus === BOOKING_STATUS.SL_RESPONSE_AWAITED ||
      drawerData.ffStatus === BOOKING_STATUS.SL_ERRORED
    ) {
      date = drawerData.ffStatusUpdatedAt;
    }
    if (drawerData.ffStatus === BOOKING_STATUS.SL_RESPONDED) {
      date = drawerData.inttraStatusUpdatedAt;
    }

    const deadline = `${getDateValue(date)?.format('DD MMM YYYY | HH:mm')}Hrs`;
    const deadlineColor = '#424242';
    if (!deadline) return;

    return (
      <div style={{ fontSize: '11px', color: `${deadlineColor}`, paddingLeft: '26px' }}>
        <span>{deadline}</span>
      </div>
    );
  };

  fetchTeams = async () => {
    const response = await fetchAllTeams({ adminTeamRestriction: true });
    if (response.isSuccess) {
      this.setState({ teams: response.data });
    } else {
      message.error(response.errorMessage);
    }
  };

  handleAccessTypeChange = async (val) => {
    if (val !== 'TEAM') this.updateTeamAccess(val);
    else this.setState({ isSelectTeamModalVisible: true });
  };

  handleTeamSelect = (team) => {
    const newAccessData: any = {};

    const newBookingAccessTeams = { ...this.state.bookingAccessTeams };
    if (newBookingAccessTeams[team.id]) delete newBookingAccessTeams[team.id];
    else newBookingAccessTeams[team.id] = `${team.name} (${team.reference_number})`;
    if (Object.keys(newBookingAccessTeams).length) {
      newAccessData.bookingAccessTeams = newBookingAccessTeams;
    }

    this.setState(newAccessData);
  };

  handleTeamModalClose = () => {
    const bookingAccessTeamIds = Object.keys(this.state.bookingAccessTeams)
    if (bookingAccessTeamIds.length) this.updateTeamAccess('TEAM', bookingAccessTeamIds);
    else this.setState({ isSelectTeamModalVisible: false });
  };

drawerTitle = () => {
  const { visibleAccessTypes, classes, drawerData, onClose, userType } = this.props;
  const accessIcons = {
    PUBLIC: <Icon type="global" />,
    PRIVATE: <Icon type="user" />,
    TEAM: <Icon type="team" />,
  };
  const {
    bookingAccessTeams,
    accessType,
    isSelectTeamModalVisible,
    teams,
    isLoading,
  } = this.state;
  const bookingAccessTeamsIds = Object.keys(bookingAccessTeams);
  const status = userType === 'SHIPPER' ? drawerData.status : drawerData.ffStatus;
  const showDownloadButton = status === 'CONFIRMED' && this.props.showDownloadButton;

  const handleDownload = async () => {
  this.setState({
    isDownloadLoading: true,
  });
  const response = await downloadBookingPurchaseOrder({ bookingId: drawerData.id });
  if (response.isSuccess) {
    downloadFileData(response.data, response.filename, true);
    message.success('Downloaded successfully');
  } else {
    message.error(response.errorMessage);
  }
  this.setState({
    isDownloadLoading: false,
  });
};

  return (
    <Row>
      <Col span={1}>
        <Icon onClick={onClose} style={{ cursor: 'pointer' }} type="close" />
      </Col>
      <Col span={3} style={{ color: '#1875F0', fontSize: `${tokens.fontSize.h1}px`, display: 'flex' }}>
        <strong>{drawerData.bookingNumber}</strong>
      </Col>
      <Col span={7}>
        {isLoading ? (
          <Spin style={{ marginLeft: 20 }} />
        ) : (
          <div className={classes.accessTypeDiv}>
            <Select
              placeholder="Booking Access"
              onSelect={this.handleAccessTypeChange}
              value={accessType}
              style={{ marginRight: '16px' }}
              disabled={userType !== 'SHIPPER'}
            >
              {defaultAccessKeys?.map((item) => {
                return (
                  <Select.Option
                    key={item}
                    disabled={
                      (!!visibleAccessTypes.length && !visibleAccessTypes.includes(item)) ||
                      (item === 'TEAM' && teams && !teams.length)
                    }
                  >
                    {accessIcons[item]} {visibleAccessTypeLabel[item]}
                  </Select.Option>
                );
              })}
            </Select>
            {!!bookingAccessTeamsIds.length && (
              <Select
                placeholder="Teams"
                mode="multiple"
                maxTagCount={1}
                value={Object.values(bookingAccessTeams)}
              >
                {bookingAccessTeamsIds.map((key) => {
                  return (
                    <Select.Option key={key} value={bookingAccessTeams[key]} disabled>
                      {bookingAccessTeams[key]}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
          </div>
        )}
      </Col>

      <Col offset={4} span={7} style={{ top: '-8px', textAlign: 'right', paddingRight: '12px' }}>
        <Row>{this.bookingStatus()}</Row>
        <Row>{this.getDeadline()}</Row>
      </Col>

      {/* Download button - only shown when status is CONFIRMED */}
      {showDownloadButton && (
        <Col span={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft: '8px' }}>
          <Icon
            type="download"
            onClick={handleDownload}
            style={{
              cursor: 'pointer',
              fontSize: '26px',
              color: tokens.colors.textSecondary,
            }}
            title="Download Booking"
          />
        </Col>
      )}
      {isSelectTeamModalVisible && (
        <TeamForInquiryAccessModal
          isVisible={isSelectTeamModalVisible}
          teams={teams}
          onCancel={this.handleTeamModalClose}
          handleTeamSelect={this.handleTeamSelect}
          bookingAccessTeams={this.state.bookingAccessTeams}
          isBooking
        />
      )}
    </Row>
  );
};

  render() {
    const { drawerData, classes } = this.props;
    return (
      <Drawer
        className={classes.drawerClass}
        width="75%"
        onClose={this.props.onClose}
        visible={this.props.isVisible}
        closable={false}
        title={this.drawerTitle()}
      >
        <Col>
          <BookingDetails
            isLoading={this.state.isLoading}
            userType={this.props.userType}
            data={drawerData}
            handleCloseSideDrawer={this.props.onClose}
            bookingData={this.state.bookingData}
          />
        </Col>
      </Drawer>
    );
  }
}
const mapStateToProps = ({ masterData, summaryDashboardReducer }, { }) => ({
  pagination: summaryDashboardReducer.pagination,
  isLoading: summaryDashboardReducer.isLoading,
  tableData: summaryDashboardReducer.tableData,
  tableColumns: summaryDashboardReducer.tableColumns,
  userType: masterData.userData.type,
  visibleAccessTypes: masterData?.visibleAccessTypes?.INQUIRY ?? [],
  showDownloadButton: masterData?.modules?.show_booking_download_button ?? false,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPagination,
      resetPagination,
      downloadContainers,
      resetAndSetBatchSize,
      setFilter,
    },
    dispatch
  );
export default injectSheet(styles)(connect(mapStateToProps, mapDispatchToProps)(BookingSideDrawer));
